<mibi-single-center-card-layout cardTitle="Passwort zurücksetzen">
    <mibi-recovery-container mibi-card-content></mibi-recovery-container>
</mibi-single-center-card-layout>
